import { Button, ButtonGroup } from '@mui/material';
import { memo } from 'react';

interface ToggleButtonProps {
  texts: [string, string];
  activeIndex: 0 | 1;
  onFirstClick: () => void;
  onSecondClick: () => void;
  'aria-label'?: string;
  color?: 'primary' | 'secondary';
}

export const ToggleButton = memo(({
  texts,
  activeIndex,
  onFirstClick,
  onSecondClick,
  'aria-label': ariaLabel = 'Toggle selection',
  color = 'primary'
}: ToggleButtonProps) => {
  return (
    <ButtonGroup aria-label={ariaLabel} color={color}>
      <Button
        variant={activeIndex === 0 ? "contained" : "outlined"}
        onClick={() => {
          if (activeIndex !== 0) onFirstClick();
        }}
      >
        {texts[0]}
      </Button>
      <Button
        variant={activeIndex === 1 ? "contained" : "outlined"}
        onClick={() => {
          if (activeIndex !== 1) onSecondClick();
        }}
      >
        {texts[1]}
      </Button>
    </ButtonGroup>
  );
});

ToggleButton.displayName = 'ToggleButton'; 